var rtlStyles={rtl:"lN-8U",ltr:"_1sPcW"};export{rtlStyles as r};
//# sourceMappingURL=rtl.rtlignore-4db7e856.js.map
